import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { DonneReferenceService } from '../../services/donne-reference.service';
import { FormGroup } from '@angular/forms';

@Component({
  selector: 'app-frequence-select',
  templateUrl: './frequence-select.component.html',
  styleUrls: ['./frequence-select.component.scss'],
  standalone: false
})
export class FrequenceSelectComponent implements OnInit {
  public frequences;

  @Input()
  id: string;

  @Input()
  value: string;

  @Output()
  valueChange: EventEmitter<string> = new EventEmitter<string>();

  @Input()
  parentFormGroup: FormGroup;

  @Input()
  formName: string;

  @Input()
  accessibilityLabel: string;

  constructor(private readonly _donneesReferenceService: DonneReferenceService) {}

  ngOnInit() {
    this.frequences = this._donneesReferenceService.typeFrequence;
  }

  changeValue(event: Event) {
    this.value = (event.target as HTMLInputElement).value;
    this.valueChange.emit(this.value);
  }

  emit() {
    const control = this.parentFormGroup.get(this.formName);
    if (control.dirty) {
      this.valueChange.emit(control.value);
    }
  }
}
